module.exports = __webpack_public_path__ + "img/not_mobile_press.b4c90bf.webp";